import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';
import { Button, useToast } from '../components/ui';
import { useForgotPasswordMutation } from '../store/customersApi';

export default function OlvideMiContrasena() {
  const toast = useToast();
  const [forgotPassword, { isLoading }] = useForgotPasswordMutation();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await forgotPassword({ email }).unwrap();
      setSent(true);
    } catch (e: any) {
      toast.error({ title: 'Algo salió mal', description: e?.data?.message ?? 'Intentá de nuevo.' });
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-sm bg-white border border-slate-200 rounded-2xl shadow-sm p-8 space-y-4">
        <h1 className="font-heading font-extrabold text-2xl text-slate-900 text-center mb-2">Recuperar contraseña</h1>

        {sent ? (
          <p className="text-sm text-slate-600 text-center">
            Si el email existe, te enviamos un enlace para restablecer tu contraseña. Revisá tu bandeja de entrada.
          </p>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <p className="text-xs text-slate-500 text-center">Ingresá tu email y te enviamos un enlace para elegir una nueva contraseña.</p>
            <div className="relative">
              <input required type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-slate-50 border border-slate-200 focus:border-indigo-500/50 focus:bg-white rounded-xl pl-10 pr-4 py-2.5 text-sm text-slate-800 placeholder-slate-400 focus:outline-none transition-colors" />
              <Mail className="w-4 h-4 text-slate-400 absolute left-3.5 top-1/2 -translate-y-1/2" />
            </div>
            <Button type="submit" variant="primary" size="lg" loading={isLoading} className="w-full">
              Enviar enlace
            </Button>
          </form>
        )}

        <p className="text-xs text-slate-500 text-center pt-2">
          <Link to="/login" className="text-indigo-600 font-semibold hover:underline">Volver a iniciar sesión</Link>
        </p>
      </div>
    </div>
  );
}
